const Menu = [
  {
    key: "routekey-home",
    label: "sidebar.dashboard",
    path: "/app/dashboard",
    icon: <i className="me-1 bi bi-house-fill"></i>,
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-product",
    label: "sidebar.product",
    path: "/app/product",
    icon: <i className="me-1 bi bi-people-fill"></i>,
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-product-batch",
    label: "sidebar.receiveCfpBatch",
    path: "/app/productbatch",
    icon: <i className="me-1 bi bi-people-fill"></i>,
    vissbleOnSmallScrren: true,
  },
  {
    key: "routekey-mobile-app-test",
    label: "sidebar.mobileApp",
    path: "/app/qrtest",
    icon: <i className="me-1 bi bi-people-fill"></i>,
    vissbleOnSmallScrren: true,
  },
  // {
  //   key: "routekey-services",
  //   label: "sidebar.services",
  //   path: "/app/services",
  //   icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //   subMenu: [
  //     {
  //       key: "routekey-services-tm",
  //       label: "Migrations",
  //       path: "/app/services/technologymigrations",
  //       icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //       vissbleOnSmallScrren: true,
  //     },
  //     {
  //       key: "routekey-services-cp",
  //       label: "Cross Platform Apps",
  //       path: "/app/services/crossplatform",
  //       icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //       vissbleOnSmallScrren: true,
  //     },
  //     {
  //       key: "routekey-services-pwa",
  //       label: "PWA",
  //       path: "/app/services/pwa",
  //       icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //       vissbleOnSmallScrren: true,
  //     },
  //   ],

  //   vissbleOnSmallScrren: true,
  // },
  // {
  //   key: "routekey-customers",
  //   label: "sidebar.customers",
  //   path: "/app/customers",
  //   icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //   // subMenu: [
  //   //   {
  //   //     key: "routekey-services-tm",
  //   //     label: "Migrations",
  //   //     path: "/app/services/technologymigrations",
  //   //     icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //   //     vissbleOnSmallScrren: true,
  //   //   },
  //   //   {
  //   //     key: "routekey-services-cp",
  //   //     label: "Cross Platform Apps",
  //   //     path: "/app/services/crossplatform",
  //   //     icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //   //     vissbleOnSmallScrren: true,
  //   //   },
  //   //   {
  //   //     key: "routekey-services-pwa",
  //   //     label: "PWA",
  //   //     path: "/app/services/pwa",
  //   //     icon: <i className="me-1 bi bi-briefcase-fill"></i>,
  //   //     vissbleOnSmallScrren: true,
  //   //   },
  //   // ],

  //   vissbleOnSmallScrren: true,
  // },
  // {
  //   key: "routekey-users",
  //   label: "sidebar.users",
  //   path: "/app/user",
  //   icon: <i className="me-1 bi bi-pc-display"></i>,
  //   vissbleOnSmallScrren: true,
  // },

];

export default Menu;
